module.exports = __webpack_public_path__ + "static/media/SV.0f299114.png";